import { render } from "./XTwitterIcon.vue?vue&type=template&id=b13d181e"
import script from "./XTwitterIcon.vue?vue&type=script&lang=js"
export * from "./XTwitterIcon.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__